// src/hooks/useAuthInitializer.ts
import React, { useEffect, useRef, useState } from 'react'; // Import React for React.FC, if using
import { useAuth } from 'react-oidc-context';
import { User } from 'oidc-client-ts'; // Import User type for clarity and safety
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from './store';
import { activateMarker } from '../features/activeMarkers';
import { showCareCenters, showWarriors, setlFilters } from '../features/filterSlice';
interface useSelectAllMarkersInterface {
    selectAll: (select: boolean ) => void,
     snapshotFilters: () => void,
    restoreFilters: () => void,
}
export const useSelectAllMarkers = ():useSelectAllMarkersInterface => {
//export function useSelectAllMarkers() {
  //const dispatch = useDispatch<AppDispatch>();
   const filterState = useSelector((state: RootState) => state.filter); // assuming your slice is called 'filters'
  const filterSnapshot = useRef<typeof filterState | null>(null);
  const dispatch = useDispatch<any>();
  const selectAll = (select: boolean): void => {
    if (!select) {
      dispatch(activateMarker({ id: null, disableHover: false }));
    }
    dispatch(showCareCenters(select));
    dispatch(showWarriors(select));
  };

  const snapshotFilters = () => {
    filterSnapshot.current = filterState;
  };

  const restoreFilters = () => {
    if (filterSnapshot.current) {
      dispatch(setlFilters(filterSnapshot.current));
    }
  };

  return {
    selectAll,
    snapshotFilters,
    restoreFilters,
  };
}


